
import { defineComponent, computed } from 'vue'

// Icons
import CardPlaceholderIcon from '@/assets/images/ic_card_placeholder_grey.svg'
import AppleIcon from '@/assets/images/ic_apple_pay.svg'
import GoogleIcon from '@/assets/images/ic_google_pay.svg'

export default defineComponent({
	name: 'TicketingPaymentMethod',

	emits: ['open-credit-card-modal'],

	props: {
		creditCard: {
			type: Object,
			default: () => ({})
		}
	},

	setup(props, { emit }) {
		// Computed
		const paymentType = computed(() => props.creditCard?.paymentGatewayType)
		const creditCardNumbers = computed(() => props.creditCard?.lastFour)
		const creditCardType = computed(() =>
			props.creditCard?.cardType?.toLowerCase()?.replace(/[/\s]/g, '')
		)
		const cardPlaceholderIcon = computed(() => CardPlaceholderIcon)
		const appleIcon = computed(() => AppleIcon)
		const googleIcon = computed(() => GoogleIcon)

		// Methods
		const openCardModal = (): void => {
			emit('open-credit-card-modal')
		}

		return {
			paymentType,
			creditCardNumbers,
			creditCardType,
			cardPlaceholderIcon,
			appleIcon,
			googleIcon,
			openCardModal
		}
	}
})
